import { jsx as l } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m53.332 50.377-.03-22.083a3.835 3.835 0 0 0-3.83-3.825H38.081l1.666-6.135a8.43 8.43 0 0 0-.015-4.47 8.452 8.452 0 0 0-8.116-6.163h-2.623l-5.148 19.211a2.284 2.284 0 0 1-1.282 1.5l-.036-4.63H13.51a4.086 4.086 0 0 0-4.081 4.081v22.974a3.96 3.96 0 0 0 3.955 3.955h9.126v-2.727h1.032a7.034 7.034 0 0 0 5.984 3.363h20.899l-1.069-3.986 3.976-1.065ZM18.56 48.065h-.05v2.727h-5.082V27.863c0-.045.036-.081.081-.081h5.048l.003.296v19.987Zm10.965 3.363a3.016 3.016 0 0 1-2.584-1.471 3.86 3.86 0 0 0-3.302-1.892h-3.08V33.307l3.06-1.02a6.274 6.274 0 0 0 4.089-4.34l4.347-16.224a4.442 4.442 0 0 1 3.823 3.215c.214.767.216 1.58.008 2.348L32.85 28.469h16.452l.006 4.337H38.934l.536 2h9.84l.007 4.251H38.808l.536 2h9.975l.006 4.25H38.829l.536 2h9.963l.005 4.121H29.526Z"
      }
    )
  }
);
export {
  o as ThumbsUp
};
